<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        合同管理
        <small>/&nbsp;合同列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">合同列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
              <form  style="margin-top:16px;" >
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">合同编号</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同编号"
                        v-model="contractNo"
                      >
                    </div>
                  <label class="col-md-1 col-form-label">合同标题</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同标题"
                        v-model="contractTitle"
                      >
                    </div>
                    <label class="col-md-1 col-form-label">合同开始日期</label>
                    <div class="col-md-3">
                      <el-date-picker
                        style="width:100%;height:34px;"
                        v-model="TimeValue"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="ChangePicker"
                      ></el-date-picker>
                    </div>

                    <div class="col-md-2"></div>
                    <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                    <div class="col-md-2 LineSpacing">
                       <el-select
                          v-model="recomId"
                          style="width:100%;font-size:12px;"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                    </div>


                      <label class="col-md-1 col-form-label LineSpacing">合同状态</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="contractStatus"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in contractStatusLists"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                    <div class="col-md-1 LineSpacing">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                      >查询</a>
                    </div>
                    <div class="col-md-11"></div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor"
                        @click="ExportClick()"
                        style="float:right;"
                      >导出</a>
                    </div>
                  </div>
                </fieldset>
              </form>
                  <el-table :data="contractList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号"  width="60"  align="center"></el-table-column>
                    <el-table-column prop="contractNo" label="合同编号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contractTitle" label="合同标题"  align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="city" label="合同区域" align="center" show-overflow-tooltip></el-table-column>
                    <!--<el-table-column label="合同品类" align="center" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-popover trigger="hover">
                          <p
                            v-for="(item,index) in scope.row.goodsNameList"
                            :key="index"
                          >{{item}}</p>
                          <div
                            slot="reference"
                            class="name-wrapper SkuHover"
                          >
                            <span>{{ scope.row.goodsNameList[0] }} &nbsp;<b v-if=" scope.row.goodsNameList.length  > 1 ">...</b></span>
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>-->
                    <el-table-column prop="recomTypeName" label="客户类型" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomName" label="服务商名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="clientSignTime" label="合同签订日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contractTerm" label="合同截止日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="currentstatus" label="合同状态" align="center"></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                      <template slot-scope="scope">
                        <el-button
                          class="btn btn-primary btn-sm ButtonColor"
                          size="small"
                          @click="DetailClick(scope.row)"
                          >合同详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
    </div>
  </div>

</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "ContractReviewList",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      contractList:[],
      contractNo: "",
      contractTitle: "",
      recomId:"",
      TimeValue: "",
      TimeValueEter:"",
      recomList: [],
      contractStatus:"",
      contractStatusList:[0,1,2],
      contractStatusLists: [
        {
          label: "待审核",
          value: "1"
        },
        {
          label: "同意审核",
          value: "2"
        },
        {
          label: "拒绝审核",
          value: "0"
        }
      ],
      director:0,
      reasonValidForm: {
        contractRemark: ''
      },
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    this.getRecomList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    DetailClick(item){
      this.$router.push({
        path:"contractreviewdetail",
        query:{
          contractId: item.contractId,
          checkId: 2
        }
      });
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    // selectOrder(val) {
    //   if (val == 21) {
    //     this.isO2O = true;
    //   } else {
    //     this.isO2O = false;
    //     this.shopName = "";
    //   }
    // },
    initdata() {
      let that = this;
      if(that.contractStatus != null && that.contractStatus != '' &&  that.contractStatus != 'undefined'){
        that.contractStatusList = that.contractStatus
      }
      const options = {
        url: "/distribution/B2cTobContractController/selectContractPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          contractStatusList:that.contractStatusList,
          director:that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.contractList = response.data.data.data.records;
          that.totalCount = response.data.data.data.total;
          for (var i in response.data.data.data.records) {
            response.data.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.data.records[i].contractStatus === 0) {
              response.data.data.data.records[i].currentstatus = "拒绝审核";
            } else if (response.data.data.data.records[i].contractStatus === 1) {
              response.data.data.data.records[i].currentstatus = "未审核";
            }else if(response.data.data.data.records[i].contractStatus === 2){
              response.data.data.data.records[i].currentstatus = "已审核";
            }
            if(response.data.data.data.records[i].recomType === 0){
              response.data.data.data.records[i].recomTypeName = "服务商";
            }else if(response.data.data.data.records[i].recomType === 1){
              response.data.data.data.records[i].recomTypeName = "分销商";
            }
            if (response.data.data.data.records[i].clientSignTime !== null) {
              response.data.data.data.records[i].clientSignTime = that.FormatAllDate(response.data.data.data.records[i].clientSignTime).slice(0,10);
            }else {
              response.data.data.data.records[i].clientSignTime = "";
            }
               if (response.data.data.data.records[i].contractTerm !== null) {
              response.data.data.data.records[i].contractTerm = that.FormatAllDate(response.data.data.data.records[i].contractTerm).slice(0,10);
            }else {
              response.data.data.data.records[i].contractTerm = "";
            }
          }
          that.contractStatusList = [0,1,2];
        } else {
          http.handleHttpError(error, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },

    ChangeDate(){
      this.ruleForm.contractTerm = this.FormatAllDate(this.ruleForm.contractTerm);
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
     //   合同列表导出
/**/
 ExportClick() {
      let that = this;
       if(that.contractStatus != null && that.contractStatus != '' &&  that.contractStatus != 'undefined'){
        that.contractStatusList = that.contractStatus
      }
      const options = {
        url: "distribution/B2cTobContractController/exportContract",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
         contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          director:that.director,
          contractStatusList:that.contractStatusList
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let   that  = this
       if(that.contractStatus != null && that.contractStatus != '' &&  that.contractStatus != 'undefined'){
        that.contractStatusList = that.contractStatus
      }
      const options = {
        url: "distribution/B2cTobContractController/exportContract",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
         contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          director:that.director,
          contractStatusList:that.contractStatusList
        }),
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "合同列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/ContractList.vue